import React, { Component } from 'react'
import {collection, query, orderBy, onSnapshot} from '@firebase/firestore'
import { firestore } from './Firebase';
import {auth} from './Firebase'
import {signOut} from "firebase/auth";
import { useNavigate } from 'react-router-dom';

const ref = collection(firestore,"Messages")
const que = query(ref, orderBy('createdAt','desc'))
export default class Dashboard extends Component {
    constructor(props){
        super(props);
        this.state = {
            messageList: []
        }
    }
    componentDidMount(){
        onSnapshot(que, (snapshot) =>{
            let messageList = []
            snapshot.docs.forEach((doc)=>{
                messageList.push({...doc.data(), id: doc.id})
            })
            this.setState({
                messageList: messageList
            })
        })
    }
    handleLogOut=()=>{
        signOut(auth).then(() => {
            alert("You are logged out");
            this.props.navigate('/Login')
          }).catch((error) => {
            console.log(error)
          });
    }

  render() {
    return (
      <div className='Dashboard'>
        <div className='Logout'><button type='submit' onClick={()=>this.handleLogOut()}>Logout</button></div>
        <h1>Dashboard</h1>
        <div className='DS'>
            <div className='InfoTable'>
                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Mobile Number</th>
                            <th>Enquiry</th>
                        </tr>
                    </thead>
                    <tbody>
                    {this.state.messageList && this.state.messageList.length > 0 && this.state.messageList.map((data,index) =>(
                        <tr key={index}>     
                            <td>{data.UserName}</td>
                            <td>{data.UserNumber}</td>
                            <td>{data.UserText}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </div>
      </div>
    )
  }
}


export function DashboardH (props){
    const navigate = useNavigate()
    return(<Dashboard navigate={navigate}/>)
}